import { render, staticRenderFns } from "./SalesCampaign.vue?vue&type=template&id=0aa98d41&scoped=true&"
import script from "./SalesCampaign.vue?vue&type=script&lang=js&"
export * from "./SalesCampaign.vue?vue&type=script&lang=js&"
import style0 from "./SalesCampaign.vue?vue&type=style&index=0&id=0aa98d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa98d41",
  null
  
)

export default component.exports